// Build timestamp from update-build.js. vite.config.ts writes it into index.html (operator-web:build-date)
// so that the JS bundle itself stays identical between two builds of the same commit.
export const buildDate =
  Number(document.querySelector('meta[name="opweb-build-date"]')?.getAttribute('content')) || 0;
